var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinsMoneySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.737,
    height: 17.518,
    viewBox: "0 0 25.737 17.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coins-money-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M13.756,344.979H1.26A1.26,1.26,0,0,1,0,343.719v-1.847a1.26,1.26,0,0,1,1.26-1.26h12.5a1.26,1.26,0,0,1,1.26,1.26v1.847A1.26,1.26,0,0,1,13.756,344.979Z",
    transform: "translate(0 -327.6)",
    fill: "#e3c129"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 13.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M13.756,379.1H1.26A1.26,1.26,0,0,1,0,377.84v1.236a1.26,1.26,0,0,0,1.26,1.26h12.5a1.26,1.26,0,0,0,1.26-1.26V377.84A1.26,1.26,0,0,1,13.756,379.1Z",
    transform: "translate(0 -375.969)",
    fill: "#d6b41a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M155.613,340.611h-6.248v4.368h6.248a1.26,1.26,0,0,0,1.26-1.26v-1.847A1.26,1.26,0,0,0,155.613,340.611Z",
    transform: "translate(-141.857 -340.611)",
    fill: "#d6b41a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M41.693,258.933H29.2a1.26,1.26,0,0,1-1.26-1.26v-1.847a1.26,1.26,0,0,1,1.26-1.26h12.5a1.26,1.26,0,0,1,1.26,1.26v1.847A1.26,1.26,0,0,1,41.693,258.933Z",
    transform: "translate(-26.533 -245.878)",
    fill: "#fae246"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(0 4.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M41.693,293.054H29.2a1.26,1.26,0,0,1-1.26-1.26v1.236a1.26,1.26,0,0,0,1.26,1.26h12.5a1.26,1.26,0,0,0,1.26-1.26v-1.236A1.26,1.26,0,0,1,41.693,293.054Z",
    transform: "translate(-26.533 -285.597)",
    fill: "#e3c129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M183.55,254.565H177.3v4.368h6.248a1.26,1.26,0,0,0,1.26-1.26v-1.847A1.26,1.26,0,0,0,183.55,254.565Z",
    transform: "translate(-168.39 -250.24)",
    fill: "#e3c129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M13.756,172.888H1.26A1.26,1.26,0,0,1,0,171.627V169.78a1.26,1.26,0,0,1,1.26-1.26h12.5a1.26,1.26,0,0,1,1.26,1.26v1.847A1.26,1.26,0,0,1,13.756,172.888Z",
    transform: "translate(0 -168.52)",
    fill: "#e3c129"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(0 4.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M13.756,207.008H1.26A1.26,1.26,0,0,1,0,205.748v1.236a1.26,1.26,0,0,0,1.26,1.26h12.5a1.26,1.26,0,0,0,1.26-1.26v-1.236A1.26,1.26,0,0,1,13.756,207.008Z",
    transform: "translate(0 -203.877)",
    fill: "#d6b41a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M155.613,168.519h-6.248v4.368h6.248a1.26,1.26,0,0,0,1.26-1.26v-1.847A1.261,1.261,0,0,0,155.613,168.519Z",
    transform: "translate(-141.857 -168.519)",
    fill: "#d6b41a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M41.693,86.12H29.2a1.26,1.26,0,0,1-1.26-1.26V83.012a1.26,1.26,0,0,1,1.26-1.26h12.5a1.26,1.26,0,0,1,1.26,1.26v1.847A1.26,1.26,0,0,1,41.693,86.12Z",
    transform: "translate(-26.533 -81.752)",
    fill: "#fae246"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(1.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M41.693,120.24H29.2a1.26,1.26,0,0,1-1.26-1.26v1.236a1.26,1.26,0,0,0,1.26,1.26h12.5a1.26,1.26,0,0,0,1.26-1.26V118.98A1.26,1.26,0,0,1,41.693,120.24Z",
    transform: "translate(-27.937 -117.109)",
    fill: "#e3c129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M183.55,81.751H177.3v4.368h6.248a1.26,1.26,0,0,0,1.26-1.26V83.011A1.26,1.26,0,0,0,183.55,81.751Z",
    transform: "translate(-169.794 -81.751)",
    fill: "#e3c129"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 7.513,
    cy: 7.513,
    r: 7.513,
    transform: "translate(10.71 2.491)",
    fill: "#fad52d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M362.53,131.316v15.027a7.513,7.513,0,0,0,0-15.027Z",
    transform: "translate(-344.307 -128.825)",
    fill: "#e3c129"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 5.921,
    cy: 5.921,
    r: 5.921,
    transform: "translate(12.303 4.084)",
    fill: "#fae246"
  }), /*#__PURE__*/React.createElement("text", {
    id: "R",
    transform: "translate(15.413 12.649)",
    fill: "#d6b41a",
    fontSize: 8,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsMoneySvgrepoCom);
export default __webpack_public_path__ + "static/media/coins-money-svgrepo-com.64069223799a14849975cd75afd0d86d.svg";
export { ForwardRef as ReactComponent };